(function(module) {
    'use strict';

    function appPreviewWrapperCtrl(App, AppTemplate, Includes, Store, $scope, $http, $q, $timeout, WS, envService) {
        this.$onInit = () => {
            this.loaded = false;
            this.records = [];
            this.APPS_URI = envService.read('APPS_URI');
            this.CUSTOM_APPS_URI = envService.read('CUSTOM_APPS_URI');
            this.SLS_URI = envService.read('SLS_URI');
            this.SERVICES_URI =  envService.read('SERVICES_URI');
            this.PLAYER_URI = envService.read('PLAYER_URI');

            if (this.mode !== 'view') {
                $scope.$watchGroup(['$ctrl.app.data.feed', '$ctrl.loaded'], ([ feed, loaded ]) => {
                    // News Apps
                    if (loaded && feed && this.appTemplate && this.appTemplate.integrationTemplate === 'rocket-news-rss') {
                        this.getFeed(feed);
                    }
                });

                $scope.$watch('$ctrl.app.data', (data) => {
                    if (this.loaded && data) {

                        // iframe apps: www, google-slides
                        if (this.appTemplate.type === 'iframe') {
                            this.src = this.getUrlFromIframeApp(this.appTemplate, { data, settings: this.app.settings });
                        }

                        // hard-coding app specific logic - this must be moved
                        if (this.appTemplate.slug === 'twitter-hashtag') {
                            if (data.hashtag && data.hashtag.length >= 2) {
                                this.getDynamic(data);
                            }
                        }

                        if (this.appTemplate.slug === 'twitter-timeline') {
                            if (data.username && data.username.length >= 2) {
                                this.getDynamic(data);
                            }
                        }

                        if (this.appTemplate.slug === 'dropbox-gallery') {
                            if (data.folder.length >= 1) {
                                this.getDynamic(data);
                            }
                        }

                        if (this.appTemplate.slug === 'message-board') {
                            if (data && data.useBucketList && data.url) {
                                this.getDynamic(data);
                            }
                        }
                    }
                }, true);

                $scope.$watch('$ctrl.app.settings', (settings) => {
                    if (this.loaded && settings) {
                        // iframe apps: www, google-slides
                        if (this.appTemplate.type === 'iframe') {
                            this.src = this.getUrlFromIframeApp(this.appTemplate, { data: this.app.data, settings });
                        }
                    }
                }, true);
            }

        };

        this.getCache = app => $q(resolve => {
            const appId = _.get(app, 'id', null);
            const appTemplateType = _.get(app, 'appTemplate.type', null);
            if (appId && appTemplateType && appTemplateType === 'integration') {
                $http({
                    method: 'GET',
                    url: `${this.SLS_URI}/apps/${appId}`,
                })
                    .then(({ data }) => {
                        $timeout(() => {
                            this.cache = data;
                            $scope.$apply();
                        });
                    })
                    .catch((error) => {
                        console.log('Preview getCache error', error);
                        this.cache = this.cache || [];
                    }).finally(() => {
                    resolve();
                });
            } else {
                this.cache = [];
                resolve();
            }
        });

        this.getDynamic = (data) => {
            // if new app should have existing integration, otherwise figure it out
            const integration = (this.integration && this.integration.id) ? this.integration : Store.getSingleModelData('integrations', this.app.integrationId);

            $timeout(() => {
                this.dynamic = [];
                $scope.$apply();
            });

            $http({
                method: 'GET',
                params: { data, credentials: integration && integration.credentials, integrationId: integration && integration.id },
                url: `${this.SLS_URI}/preview/${this.appTemplate.slug}`,
            })
                .then(({ data }) => {
                    this.onError({ $event: { name: 'preview', value: null } });
                    this.dynamic = data;
                })
                .catch((error) => {
                    if (this.appTemplate.slug === 'dropbox-gallery') {
                        if (error && error.status === 409) this.onError({ $event: { name: 'preview', value: `Sorry, we could not find this folder. Please check if such a folder exists in your Dropbox: "Apps/SignageRocket/${data.folder}"` } });
                    } else {
                        this.onError({ $event: { name: 'preview', value: 'Sorry, we could not get the data you asked for. Please try another value' } });
                    }
                    console.log('Preview getDynamic error', error);
                });
        };

        this.getFeed = (feed) => {
            $timeout(() => {
                this.dynamic = [];
                $scope.$apply();
            });
            const provider = this.appTemplate.slug.replace('-news', '');
            const url = `${this.SERVICES_URI}/feeds/preview/${provider}/${feed}`;

            $http({
                method: 'GET',
                url,
            })
                .then(({ data }) => {
                    this.onError({ $event: { name: 'preview', value: null } });;
                    this.dynamic = data;
                    this.cache = data;
                })
                .catch((error) => {
                    this.onError({ $event: { name: 'preview', value: 'Sorry, we could not get the data you asked for. Please try another value' } });
                    console.log('Preview getDynamic error', error);
                });
        };

        this.getUrlFromIframeApp = (appTemplate, app) => {
            if (app && app.data) {

                if (appTemplate.slug === 'google-slides' && app.data.url) {
                    return app.data.url.replace('/pub?', '/embed?rm=minimal&');
                }

                // if (appTemplate.slug === 'www' && app.data.username && app.data.password) {
                //     return `${this.SLS_URI}/http-basic-auth/${app.id}`;
                // }

                const URL = _.get(app, 'data.url', null);
                return (URL && URL.includes('https://') || URL && URL.includes('http://')) ? URL : null;
            }
        };

        this.buildSrc = (appTemplate) => {
            const { id, slug, type, appSource, realm, version, accountId } = (appTemplate || {});

            if (type === 'iframe') return this.getUrlFromIframeApp(appTemplate, this.app);
            if (appSource) return appSource;

            const SLUG =  slug || realm;
            switch (realm) {
                // OLD CUSTOM
                // case 'custom':
                //     return `${this.CUSTOM_APPS_URI}/account-${accountId}/app-template-${id}/version-${version}/index.html?version=${version}`;
                case 'rocket': {
                    const accountIdFromCookie = Store.getCurrentAccountId();
                    return `${this.PLAYER_URI}/#/preview/${SLUG}?preview=true&accountId=${accountIdFromCookie}&realm=${realm}&id=${id}&version=${version}`;
                }
                case 'custom': {
                    const accountIdFromCookie = Store.getCurrentAccountId();
                    return `${this.PLAYER_URI}/#/preview/${SLUG}?preview=true&accountId=${accountIdFromCookie}&realm=${realm}&id=${id}&version=${version}`;
                }
                default:
                    return `${this.APPS_URI}/${SLUG}/index.html`;
            }
        };

        this.setSrcFromApp = (app) => {
            this.src = this.buildSrc(_.get(app, 'appTemplate', {}));
            // return to continue in the promise chain
            return app;
        };

        this.setSrcFromAppTemplate = (appTemplate) => {
            this.src = this.buildSrc(appTemplate);
            // return to continue in the promise chain
            return appTemplate;
        };

        this.getAppById = (appId) => {
            const appFromStore = Store.getSingleModelData('apps', appId);
            if (!appFromStore) {
                return App.findById({ id: appId, filter: Includes.apps }).$promise;
            } else {
                const deferred = $q.defer();
                $timeout(() => {
                    return deferred.resolve(appFromStore);
                });
                return deferred.promise;
            }
        };

        this.setApp = (app) => {
            this.app = app;
            this.appTemplate = app.appTemplate;

            if (app.appTemplate.live) this.subscribeToCustomAppVersionChange(app.appTemplate.id);
            // return to continue in the promise chain
            return app;
        };

        this.getAppTemplateById = (appTemplateId, options) => {
            // force it
            if (_.get(options, 'force')) return AppTemplate.findById({ id: appTemplateId }).$promise;

            const appTemplateFromStore = Store.getSingleModelData('appTemplates', appTemplateId);
            if (!appTemplateFromStore) {
                return AppTemplate.findById({ id: appTemplateId }).$promise;
            } else {
                const deferred = $q.defer();
                $timeout(() => {
                    return deferred.resolve(appTemplateFromStore);
                });
                return deferred.promise;
            }
        };

        this.setAppTemplate = (appTemplate) => {
            this.appTemplate = appTemplate;
            if (appTemplate.live) this.subscribeToCustomAppVersionChange(appTemplate.id);

            return appTemplate;
        };

        this.$onDestroy = () => {
            if (this.appId) {
                const name = `app:${this.appId}:dynamic`;
                WS.event.unsubscribe(name);
            }
            _.each(this.records, (record) => {
                record.unsubscribe();
                record.discard();
            });
        };

        this.subscribeToDynamicData = (appId) => {
            const eventName = `app:${appId}:dynamic`;
            WS.event.subscribe(eventName, (message) => {
                $timeout(() => {
                    this.dynamic = message;
                    $scope.$apply();
                });
            });
        };

        this.subscribeToCustomAppVersionChange = (appTemplateId) => {
            const recordName = `appTemplate:${appTemplateId}`;
            WS.record.getRecord(recordName).whenReady((record) => {
                record.subscribe(() => {
                    this.onCustomTemplateVersionChange();
                });
                this.records.push(record);
            });
        };

        this.onCustomTemplateVersionChange = () => {
            this.loaded = false;
            this.getAppTemplateById(this.appTemplate.id, { force: true })
                .then(this.setAppTemplate)
                .then(this.setSrcFromAppTemplate)
                .then(() => {
                    this.loaded = true;
                });
        };

        this.$onChanges = ({ appId, appTemplateId }) => {
            // on edit screen use app or on display view
            if (this.mode === 'edit' && appId && appId.currentValue || this.mode === 'view' && appId && appId.currentValue) {
                if (appId.previousValue.length && appId.currentValue !== appId.previousValue) {
                    const name = `app:${appId.previousValue}:dynamic`;
                    WS.event.unsubscribe(name);
                    this.loaded = false;
                }

                this.getAppById(appId.currentValue)
                    .then(this.setApp)
                    .then(this.setSrcFromApp)
                    .then(this.getCache)
                    .then(() => {
                        this.loaded = true;
                        this.subscribeToDynamicData(appId.currentValue);
                    });
            }

            // new app screen
            if (this.mode === 'add' && appTemplateId && appTemplateId.currentValue) {
                if (appTemplateId.previousValue.length && appTemplateId.currentValue !== appTemplateId.previousValue) {
                    this.loaded = false;
                }

                this.getAppTemplateById(appTemplateId.currentValue)
                    .then(this.setAppTemplate)
                    .then(this.setSrcFromAppTemplate)
                    .then(() => {
                        this.cache = this.cache ? this.cache : [];
                        this.loaded = true;
                    });
            }
        };
    }

    module
        .component('appPreviewWrapper', {
            controller: appPreviewWrapperCtrl,
            templateUrl: '/js/components/app-preview-wrapper/app-preview-wrapper.html',
            bindings: {
                mode: '@',
                appId: '@',
                appTemplateId: '@',

                app: '=',
                cache: '=',
                dynamic: '=',
                onError: '&',
            },
        });

})(angular.module('rocket.components'));
